export default __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-Greek-3ca86aafe5c995229b5aabe6a9de439b.woff";